export default (string, lenght, ellipsis = true) => {
  const ending = ellipsis ? '...' : '';
  if (string.length > lenght) {
    return string.substring(0, lenght - ending.length) + ending;
  }
  return string;
};
